/**
 * The wizard's nine steps, in the design's words (the prototype's STEPS, after
 * Welcome). Step 0 is the welcome screen and step 10 the done screen; neither is
 * on the rail.
 */
export const ONBOARDING_STEPS = [
  'About you',
  'Business',
  'Miya',
  'Phone number',
  'Verification',
  'Calendar',
  'Test call',
  'Plan',
  'Payment',
] as const

/** The step that shows "To do" on the rail when verification is left for later. */
export const VERIFICATION_STEP = 5

/** Names a group of buttons (chips, radio cards) for assistive technology. */
export interface GroupA11yProps {
  'aria-label'?: string
  'aria-labelledby'?: string
  'aria-describedby'?: string
  'aria-invalid'?: boolean
}
